import { render, staticRenderFns } from "./dblxForm.vue?vue&type=template&id=c61c0ac0&scoped=true"
import script from "./dblxForm.vue?vue&type=script&lang=js"
export * from "./dblxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61c0ac0",
  null
  
)

export default component.exports